module.exports = __webpack_public_path__ + "static/img/mobile_gywm_zzry_img_bg.a672a5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_gywm_zzry_img_bg.png
// module id = pPHt
// module chunks = 21